export default "__VITE_ASSET__BgqXZ8Pm__"